<template>
    <v-content>
        <v-app>
            <v-container grid-list-xl text-xs-center fluid class="container-transactions">
                <v-layout row wrap>
                    <v-flex xs2>
                        <v-text-field v-model="search.transactionId" append-icon="search" label="Transaction ID" clearable @click:clear="resetFilter(search.transactionId)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="search.status" dense :items="statusOptions" label="Status" append-icon="search" @change="searchTransactions"></v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.holder" append-icon="search" label="Card Holder" clearable @click:clear="resetFilter(search.holder)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="search.paymentType" :items="paymentTypeOptions" label="Payment Type" multiple dense append-icon="search" @change="searchTransactions">
                           <template v-slot:selection="{ item, index }">
                                <v-chip small v-if="index === 0">
                                    <span>{{ item.text }}</span>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption">(+{{ search.paymentType.length - 1 }} others)</span>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.merchantTransactionId" append-icon="search" label="Merchant Transaction ID" clearable @click:clear="resetFilter(search.merchantTransactionId)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="search.paymentBrand" :items="paymentBrandOptions" dense label="Payment Brand" append-icon="search" @change="searchTransactions"></v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.amount" append-icon="search" label="Amount" clearable @click:clear="resetFilter(search.amount)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="search.recurringType" dense :items="recurringTypeOptions" label="Recurring Type" append-icon="search" @change="searchTransactions"></v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="search.clearingInstitute" class="clearing-institute" dense clearable @click:clear="resetFilter(search.clearingInstitute)" :items="clearingInstituteOptions" item-text="name" item-value="name" label="Clearing Institutes" append-icon="search" @change="searchTransactions"></v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.resultCode" append-icon="search" label="Result Code" clearable @click:clear="resetFilter(search.resultCode)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.bin" append-icon="search" label="BIN" clearable @click:clear="resetFilter(search.bin)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.last4Digits" append-icon="search" label="Last 4 Digits" clearable @click:clear="resetFilter(search.last4Digits)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-dialog ref="fromDateDialog" v-model="fromDateModal" :return-value.sync="search.fromDate" persistent lazy full-width width="290px">
                            <v-text-field slot="activator" v-model="search.fromDate" label="From Date" append-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="search.fromDate" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="fromDateModal = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-flex xs2>
                        <v-dialog ref="toDateDialog" v-model="toDateModal" :return-value.sync="search.toDate" persistent lazy full-width width="290px">
                            <v-text-field slot="activator" v-model="search.toDate" label="To Date" append-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="search.toDate" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="toDateModal = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex xs12>
                        <v-data-table id="transactions-table" :headers="tableHeaders" :items="transactions" :rows-per-page-items="rowsPerPage" :loading="loading" class="elevation-1">
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td v-if="props.item.code.substring(0, 3) == '000'" class="justify-center layout px-0 status-column">
                                    <v-icon small class="mr-2 vertical-align-middle" color="green">
                                        done
                                    </v-icon>
                                </td>
                                <td v-else class="justify-center layout px-0 status-column">
                                    <v-icon small class="mr-2 vertical-align-middle" color="red">
                                        clear
                                    </v-icon>
                                </td>
                                <td class="text-xs-left">{{ props.item.insTs }}</td>
                                <td class="text-xs-left">Enhance You Ltd</td>
                                <td v-if="props.item.entityId == '8ac9a4c866ab213b0166b13802d320a0'" class="text-xs-left">Ketoslim Discount</td>
                                <td v-else-if="props.item.entityId == '8ac9a4c866ab213b0166b121dffd203d'" class="text-xs-left">Instasmooth</td>
                                <td v-else-if="props.item.entityId == '8ac9a4c866ab213b0166b12738612057'" class="text-xs-left">Instaslim Discount</td>
                                <td v-else-if="props.item.entityId == '8ac9a4c866ab213b0166b122dde32041'" class="text-xs-left">Instalift</td>
                                <td v-else-if="props.item.entityId == '8ac9a4c866ab213b0166b1262ada204e'" class="text-xs-left">Instacleanse Discount</td>
                                <td v-else-if="props.item.entityId == '8ac9a4ca692f2ddb0169363ce10e2622'" class="text-xs-left">SecureTrading - Merchant Account #1</td>
                                <td v-else-if="props.item.entityId == '8ac9a4ca692f2ddb0169363d3fac2627'" class="text-xs-left">SecureTrading - Merchant Account #2</td>
                                <td class="text-xs-left">{{ props.item.uniqueId }}</td>
                                <td class="text-xs-left">{{ props.item.holder }}</td>
                                <td class="text-xs-left">{{ props.item.paymentType }}</td>
                                <td class="text-xs-left">{{ props.item.merchantTransactionId }}</td>
                                <td v-if="props.item.paymentBrand == 'VISA' && props.item.paymentType != '3D'" class="text-xs-left">
                                    <div class="visa payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'VISA' && props.item.paymentType == '3D'" class="text-xs-left">
                                    <div class="verified-by-visa payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'VISAELECTRON' || props.item.paymentBrand == 'VISADEBIT'" class="text-xs-left">
                                    <div class="visa payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'MASTER' && props.item.paymentType != '3D'" class="text-xs-left">
                                    <div class="mastercard payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'MASTER' && props.item.paymentType == '3D'" class="text-xs-left">
                                    <div class="mastercard-securecode payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'AMEX'" class="text-xs-left">
                                    <div class="amex payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'MAESTRO'" class="text-xs-left">
                                    <div class="maestro payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'JCB'" class="text-xs-left">
                                    <div class="jcb payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'DINERS'" class="text-xs-left">
                                    <div class="diners payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'DISCOVER'" class="text-xs-left">
                                    <div class="discover payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'BCMC'" class="text-xs-left">
                                    <div class="bcmc payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'CHINAUNIONPAY'" class="text-xs-left">
                                    <div class="chinaunionpay payment-brand"></div>
                                </td>
                                <td v-else class="payment-brand-text">{{ props.item.paymentBrand }}</td>
                                <td class="text-xs-left">{{ props.item.amount }}</td>
                                <td class="text-xs-left">{{ props.item.currency }}</td>
                                 <td class="text-xs-left">
                                    <v-btn icon @click="tranInfo = props.item; tranInfoDialog = true;">
                                        <v-icon color="grey">info</v-icon>
                                    </v-btn>         
                                </td>    
                            </template>
                        </v-data-table>
                        <transaction-information :visible="tranInfoDialog" :tranInfo="tranInfo" @closeDialog="tranInfoDialog = false" @getTransactions="searchTransactions()"></transaction-information>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
    import axios from 'axios';
    import TransactionInformation from '../components/TransactionInformationV2Alto.vue';

    export default {
        data() {
            return {
                pagination: { 'sortBy': 'processing_time', 'descending': true },
                search: {
                    transactionId: null,
                    status: null,
                    holder: null,
                    paymentType: [],
                    merchantTransactionId: null,
                    paymentBrand: null,
                    amount: null,
                    recurringType: null,
                    clearingInstitute: null,
                    resultCode: null,
                    bin: null,
                    last4Digits: null,
                    fromDate: new Date().toISOString().substr(0, 10),
                    toDate: new Date().toISOString().substr(0, 10)
                },
                stats: {
                    totalTransactions: 0,
                    debitAmount: 0,
                    debitTransactions: 0,
                    creditAmount: 0,
                    creditTransactions: 0,
                    rejectedTransactions: 0
                },          
                statusOptions: [
                            { value: null, text: "All" },
                            { value: 0, text: "Failed" },
                            { value: 1, text: "Success" }
                ],
                paymentTypeOptions: [
                                { value: "3D", text: "3D" },
                                { value: "CP", text: "Capture" },
                                { value: "CR", text: "Credit" },
                                { value: "DB", text: "Debit" },
                                { value: "DR", text: "Deregister" },
                                { value: "DS", text: "Deschedule" },
                                { value: "PA", text: "Pre-authorisation" },
                                { value: "RF", text: "Refund" },
                                { value: "RG", text: "Registration" },
                                { value: "RR", text: "Reregister" },
                                { value: "RS", text: "Reschedule" },
                                { value: "RV", text: "Reversal" },
                                { value: "SD", text: "Schedule" }
                ],
                paymentBrandOptions: [
                                { value: null, text: "All" },
                                { value: "AMEX", text: "AMEX" },
                                { value: "BCMC", text: "BCMC" },
                                { value: "CHINAUNIONPAY", text: "CHINAUNIONPAY" },
                                { value: "DINERS", text: "DINERS" },
                                { value: "DISCOVER", text: "DISCOVER" },
                                { value: "JCB", text: "JCB" },
                                { value: "MAESTRO", text: "MAESTRO" },
                                { value: "MASTER", text: "MASTERCARD" },
                                { value: "PAYSAFECARD", text: "PAYSAFECARD" },
                                { value: "VISA", text: "VISA" },
                                { value: "VISADEBIT", text: "VISADEBIT" },
                                { value: "VISAELECTRON", text: "VISAELECTRON" }
                ],
                recurringTypeOptions: [
                                { value: null, text: "All" },
                                { value: "INITIAL", text: "INITIAL" },
                                { value: "REPEATED", text: "REPEATED" }
                ],
                clearingInstituteOptions: [],
                rowsPerPage:[10, 25, 50, 100],
                loading: true,
                transactions: [],
                tableHeaders: [{ text: 'Status', sortable: false, align: 'center' },
                               { text: 'Date', sortable: false },
                               { text: 'Merchant', sortable: false },
                               { text: 'Channel', sortable: false },
                               { text: 'UUID', sortable: false },
                               { text: 'Card Holder', value: 'holder', sortable: false },
                               { text: 'Payment Type', value: 'payment_type', sortable: false },
                               { text: 'Merchant Transaction ID', value: 'merchantTransactionId', sortable: false },
                               { text: 'Payment Brand', value: 'paymentBrand', sortable: false, align: 'center' },
                               { text: 'Amount', value: 'amount', sortable: false },
                               { text: 'Currency', value: 'currency', sortable: false },
                               { text: 'Information', value: '', sortable: false }],
                channels: [],
                menu: false,
                fromDateModal: false,
                toDateModal: false,
                tranInfoDialog: false,
                tranInfo: null,
                merchantsDialog: false
            }
        },
        components: {
            'transaction-information': TransactionInformation
        },
        beforeMount() {
           this.getTransactions();
           this.getClearingInstitutes();
        },
        computed: {

        },
        methods: {
            getTransactions() {
                axios({
                method: 'get',
                url: 'https://controlapi.totalprocessing.com/api/get-transactions-v2-alto',
                data: { },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.transactions = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            searchTransactions() {
                this.loading = true;

                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/search-transactions-v2-alto',
                data: { search: this.search },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.transactions = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getClearingInstitutes() {
                axios({
                method: 'get',
                url: 'https://controlapi.totalprocessing.com/api/get-clearing-institutes',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.clearingInstituteOptions = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            resetFilter(field) {
                this.field = null;
                this.searchTransactions();
            },
            handleDateChange() {
                if(this.search.toDate < this.search.fromDate) {
                    this.search.fromDate = this.search.toDate;
                }
                this.$refs.fromDateDialog.save(this.search.fromDate);
                this.$refs.toDateDialog.save(this.search.toDate);
                this.searchTransactions();
            }
        }
    }
</script>

<style>

</style>
